/**
 * @author chandu
 * Press constants
 *
 */

export const NEWS_ARTICLES = [
  {
    key: 1,
    newsLink: 'https://www.pymnts.com/payments-as-a-service/2022/card-networks-leverage-strategic-investments-to-secure-eu-foothold/',
    newsDate: 'September 16, 2022',
    newsTitle: 'Indian FinTech Zaggle Launches AP, Credit Card Payments Platform',
    newsDec: 'Indian FinTech company Zaggle has reportedly launched a product called Zoyer that brings accounts payable (AP) and credit card payments together on a single platform.',
  },
  {
    key: 2,
    newsLink: 'https://www.ndtv.com/business/budget-2022-digitising-indias-growth-opportunities-2760450',
    newsDate: 'February 10, 2022',
    newsTitle: 'Opinion: How Budget 2022 Is Digitising India\'s Growth Opportunities',
    newsDec: 'Union Budget 2022 has achieved a fine balance between macro-growth and all-inclusive welfare through the establishment of a digital economy and a booming FinTech ecosystem.',
  },
  {
    key: 6,
    newsLink: 'https://bwdisrupt.businessworld.in/article/Zaggle-Partners-With-EarlySalary/16-11-2021-412114/',
    newsDate: 'November 16, 2021',
    newsTitle: 'Zaggle Partners With EarlySalary',
    newsDec: 'This partnership will be beneficial to EarlySalary in terms of extending its financial wellness program by leveraging the large user base of Zaggle especially in the corporate and the enterprise segment.',
  },
  {
    key: 7,
    newsLink: 'https://www.cxooutlook.com/the-importance-of-seamless-cash-flow-management-for-smes/',
    newsDate: 'October 4, 2021',
    newsTitle: 'The Importance of Seamless Cash Flow management for SMEs',
    newsDec: 'Raj is a seasoned professional with over 22 years of experience working in India and the US. He is a serial entrepreneur and has built and sold businesses in areas such as Financial Services, Prepaid Internet Retail, Loyalty, Merchandising, Reward and Recognition, Open Banking, and Expense Management. Raj is also an active Angel Investor and Mentor and has invested in over 25 companies.',
  },
  {
    key: 15,
    newsLink: 'https://www.outlookindia.com/outlookmoney/tax/digitisation-a-win-win-for-employees-employers-6462',
    newsDate: 'March 17, 2021',
    newsTitle: 'Digitisation A Win-Win For Employees & Employers',
    newsDec: 'By embracing digitisation, companies have been able to solve complicated problems associated with routine tasks. . . .',
  },
  {
    key: 18,
    newsLink: 'https://menafn.com/1101631783/Zaggle-Wins-the-Best-Employee-Engagement-Award-in-The-B2B-Segment-at-the-29th-Edition-of-World-HRD-Congress-Awards-2021',
    newsDate: 'February 20, 2021',
    newsTitle: 'Zaggle Wins the Best Employee Engagement Award in The B2B Segment at the 29th Edition of World HRD Congress & Awards 2021',
    newsDec: 'Zaggle, a leading award winning FinTech company was conferred with the Best Employee Engagement Award in the B2B segment in the Employee Engagement Leadership Awards Category at the 29th edition of World HRD Congress & Awards 2021.',
  },
  {
    key: 21,
    newsLink: 'https://www.pninews.com/raj-n-among-the-most-promising-business-leaders-of-asia/',
    newsDate: 'December 16, 2020',
    newsTitle: 'Raj N among the ‘Most Promising Business Leaders of Asia',
    newsDec: 'Mr. Raj N, the Founder and Chairman of leading FinTech company, Zaggle has been named among the “Most Promising Business Leaders of Asia” at The Economic Times ‘Asian Business Leaders Conclave 2020’.',
  },
  {
    key: 22,
    newsLink: 'https://indianshowbiz.wordpress.com/2020/12/16/zaggle-promoter-raj-n-among-the-most-promising-business-leaders-of-asia-released-at-the-economic-times-asian-business-leaders-conclave-2020/',
    newsDate: 'December 16, 2020',
    newsTitle: 'Zaggle promoter Raj N among the ‘Most Promising Business Leaders of Asia’ released at The Economic Times Asian Business Leaders Conclave 2020',
    newsDec: 'Mr. Raj N, the Founder and Chairman of leading FinTech company, Zaggle has been named among the “Most Promising Business Leaders of Asia” at The Economic Times ‘Asian Business Leaders Conclave 2020’.',
  },
  {
    key: 23,
    newsLink: 'https://menafn.com/1101288744/Zaggle-promoter-Raj-N-among-the-Most-Promising-Business-Leaders-of-Asia-released-at-The-Economic-Times-Asian-Business-Leaders-Conclave-2020',
    newsDate: 'December 16, 2020',
    newsTitle: 'Zaggle promoter Raj N among the ‘Most Promising Business Leaders of Asia’ released at The Economic Times Asian Business Leaders Conclave 2020',
    newsDec: 'Mr. Raj N, the Founder and Chairman of leading FinTech company, Zaggle has been named among the “Most Promising Business Leaders of Asia” at The Economic Times ‘Asian Business Leaders Conclave 2020’.',
  },
  {
    key: 24,
    newsLink: 'https://menafn.com/1101184823/Zaggle-wins-the-best-Fintech-Corporate-Innovation-Program-award-at-The-ETBFSI-Innovation-Tribe-Awards',
    newsDate: 'November 25, 2020',
    newsTitle: 'Zaggle wins the best Fintech Corporate Innovation Program award at The ETBFSI Innovation Tribe Awards',
    newsDec: 'Zaggle Prepaid Ocean Services was conferred the best Fintech Corporate Innovation Program award at The Economic Times BFSI Innovation Tribe Awards 2020.',
  },
  {
    key: 25,
    newsLink: 'https://economictimes.indiatimes.com/magazines/panache/wfh-woes-zaggle-chairmans-daily-screen-time-went-up-from-6-to-10-hours-during-lockdown/articleshow/79314666.cms',
    newsDate: 'November 21, 2020',
    newsTitle: 'WFH woes: Zaggle Chairman\'s daily screen-time went up from 6 to 10 hours during lockdown',
    newsDec: 'The two gadgets that I can’t live without are my Fitbit smartwatch and smartphone. The smartwatch tracks my physical activity and how the body is responding to it. My phone contains a lot of my information and data required on a day-today basis.',
  },
  {
    key: 28,
    newsLink: 'https://www.business-standard.com/article/pti-stories/fintech-startup-zaggle-ties-up-with-visa-for-innovative-paymentssolutions-for-smes-120052300687_1.html',
    newsDate: 'May 23, 2020',
    newsTitle: 'Fintech startup Zaggle ties up with Visa for innovative paymentssolutions for SMEs',
    newsDec: 'Fintech startup Zaggle on Saturday said it has partnered with payments technology major Visa to launch innovative payment solutions for SMEs and startups.',
  },
  {
    key: 29,
    newsLink: 'https://economictimes.indiatimes.com/small-biz/startups/newsbuzz/fintech-startup-zaggle-joins-hands-with-visa-to-launch-payment-solutions-for-smes-startups/articleshow/75917620.cms',
    newsDate: 'May 23, 2020',
    newsTitle: 'Fintech startup Zaggle joins hands with Visa to launch payment solutions for SMEs, startups',
    newsDec: 'Fintech startup, Zaggle, has announced a partnership with Visa to launch innovative payment solutions for SMEs and startups.',
  },
  {
    key: 30,
    newsLink: 'https://www.thehindu.com/business/zaggle-visa-tie-up-for-sme-payments/article31660334.ece',
    newsDate: 'May 23, 2020',
    newsTitle: 'Zaggle, Visa tie up for SME payments',
    newsDec: 'Zaggle, a financial technology start-up, has announced a partnership with Visa to launch payment solutions for SMEs and start-ups.',
  },
  {
    key: 31,
    newsLink: 'https://www.newindianexpress.com/lifestyle/health/2020/may/08/i-want-to-see-a-better-me-post-covid-19-zaggle-founder-raj-n-phani-2140658.html',
    newsDate: 'May 08, 2020',
    newsTitle: 'I want to see a better me post COVID-19: Zaggle founder Raj N',
    newsDec: 'COVID-19 took everyone by surprise. No one had the time to think as to what needs to be done or how it should be done in such a situation.',
  },
  {
    key: 32,
    newsLink: 'https://www.businesstoday.in/bt-buzz/news/bt-buzz-mukesh-ambani-mark-zuckerberg-and-the-700-billion-kirana-puzzle/story/401746.html',
    newsDate: 'April 22, 2020',
    newsTitle: 'BT Buzz: Mukesh Ambani, Mark Zuckerberg and the $700 billion kirana puzzle',
    newsDec: '"RIL now could leverage WhatsApp\'s userbase and increase its platform\'s reach to digitise the kirana stores and their supply chain to potentially go far beyond other players like Paytm," says, Avinash Godkhindi, MD at fintech firm Zaggle.',
  },
  {
    key: 33,
    newsLink: 'https://bfsi.economictimes.indiatimes.com/news/fintech/covid-19-is-a-turning-point-for-this-fintech/74861775',
    newsDate: 'March 28, 2020',
    newsTitle: 'Covid-19 is a turning point for this FinTech',
    newsDec: 'While most Fintechs are grappling with the shocks of coronavirus pandemic and trying new ways to absorb them, Zaggle, a prepaid card services firm, has found its sweet spot in this unprecedented virus outbreak.',
  },
  {
    key: 41,
    newsLink: 'https://www.thehindubusinessline.com/news/zaggle-launches-expense-management-solution/article26006382.ece',
    newsDate: 'January 16, 2019',
    newsTitle: 'Zaggle launches expense management solution',
    newsDec: 'Zaggle, a solution provider for digital payments, has launched its Expense Management Solution.',
  },
  {
    key: 42,
    newsLink: 'https://timesofindia.indiatimes.com/business/india-business/zaggle-launches-expense-management-solution/articleshow/67559086.cms',
    newsDate: 'January 16, 2019',
    newsTitle: 'Zaggle launches expense management solution',
    newsDec: 'City-based digital payments, employee benefits rewards & recognition, loyalty, and gift cards solutions provider Zaggle on Wednesday announced the launch of its expense management solution that allows enterprises to manage their entire expense process and manage cash flows using data analytics, thus, eliminating cases of fraudulent spends and cumbersome paperwork.',
  },
];



// WEBPACK FOOTER //
// client/containers/Press/constants.js